import useValidContext from '../../hooks/useValidContext';
import UserContext from './UserContext';

function useUser() {
  return useValidContext(UserContext, 'useUser', 'UserProvider');
}

export default useUser;
